import {
  Component,
  ContentChild,
  Input,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import { TabContentDirective } from './tab-content.directive';

/**
 * A single tab element and it's content. This is used alongside the `TabGroupComponent` for displaying the active tab.
 * To have your content lazy loaded only when the tab is active wrap the tab content with `<ng-template>` tags and
 * use the `TabContentDirective`.
 */
@Component({
  selector: 'ps-ui-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.css'],
})
export class TabComponent {
  /** The label to display for this tab */
  @Input() label: string = '';

  @Input() icon: string = '';
  /** Disable this tab */
  @Input() disabled: boolean = false;

  @Input() count?: number;
  @Input() className?: string = '';

  /** Template inside the TabComponent view that contains an `<ng-content>`. */
  @ViewChild(TemplateRef, { static: true })
  private _implicitContent: TemplateRef<any> | null = null;

  /** Lazy loaded template that's wrapped in ng-template tags and using the psUiTabContent directive */
  @ContentChild(TabContentDirective, { read: TemplateRef, static: true })
  private _explicitContent: TemplateRef<any> | null = null;

  get content() {
    return this._explicitContent || this._implicitContent;
  }

  constructor() {}
}
